/** Format elapsed whole seconds as HH:MM:SS (matches PresenterView stopwatch display). */
export function formatStopwatchSeconds(totalSec) {
  const s = Math.max(0, Math.floor(Number(totalSec) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return [h, m, sec].map((n) => String(n).padStart(2, '0')).join(':');
}
